import React, { useState } from 'react'
import { LayoutBand, colors, Separator, Row, TextField, Button, H2 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

import useApac from '../../hooks/useApac'

export default function SurnameSearchSection({ backgroundColor = colors.gray02 }) {
  const { t } = useTranslation()
  const [surname, setSurname] = useState('')
  const { site } = useApac()

  function onChange(e) {
    setSurname(e.target.value?.trim())
  }

  function handleSearch() {
    if (surname) {
      globalThis.location.assign(`/${site}/surname/${surname}`)
    }
  }

  return (
    <LayoutBand marginY="xl" color={backgroundColor}>
      <H2 centered size="H4">
        {t('apac.section-templates.search-surname-section.title', 'Search Another Surname')}
      </H2>
      <Separator />
      <Row alignX="center" wrap>
        <TextField
          placeholder={t('apac.section-templates.search-surname-section.input-label', 'Enter a surname')}
          aria-label={t('apac.section-templates.search-surname-section.input-label', 'Enter a surname')}
          value={surname}
          onChange={onChange}
          onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
        />
        <Button
          emphasis="high"
          color="gray"
          onClick={handleSearch}
          disabled={!surname.trim()}
          linkName="button: search: click"
        >
          {t('common-ui:search')}
        </Button>
      </Row>
    </LayoutBand>
  )
}
